module.exports = __webpack_public_path__ + "static/media/s_v10_32.512e4cc2.mp3";